import config from '../config/analytics.json';
const PUBLIC_HOSTS = ['www.kavakarchitects.com', 'kavakarchitects.com'];
export function publicPage(location) {
  return location.protocol === 'https:' && PUBLIC_HOSTS.includes(location.hostname) && !/^\/(?:(?:fa|en)\/)?admin(?:\/|$)/.test(location.pathname);
}
export function safeUrl(value) {
  try { const url = new URL(value); return url.origin + url.pathname; } catch { return ''; }
}
export function sanitizeForLocation(event, location) {
  if (!event || !publicPage(location) || !['$pageview', 'contact_click'].includes(event.event)) return null;
  // Keep required SDK routing/anonymous identity fields plus selected page/browser properties.
  // The public token must survive before_send so ingestion can resolve the project.
  const allowed = ['token', 'distinct_id', '$device_id', '$process_person_profile', '$is_identified', '$current_url', '$pathname', '$host', '$referrer', '$referring_domain', '$browser', '$browser_version', '$os', '$os_version', '$device_type', '$screen_height', '$screen_width', '$viewport_height', '$viewport_width', '$session_id', '$window_id', '$lib', '$lib_version', 'language', 'contact_method'];
  const properties = Object.fromEntries(Object.entries(event.properties || {}).filter(([key]) => allowed.includes(key)));
  for (const key of ['$current_url', '$referrer']) if (properties[key]) properties[key] = safeUrl(properties[key]);
  return { ...event, properties };
}
export function sanitizeEvent(event) { return sanitizeForLocation(event, window.location); }
let loading;
export function analyticsClient() {
  if (!publicPage(window.location)) return Promise.resolve(null);
  if (!loading) loading = import('posthog-js').then(({default: client}) => {
    client.init(process.env.REACT_APP_POSTHOG_KEY || config.projectKey, {
      api_host: process.env.REACT_APP_POSTHOG_API_HOST || config.apiHost,
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      disable_session_recording: true,
      person_profiles: 'never',
      persistence: 'localStorage',
      advanced_disable_feature_flags: true,
      before_send: sanitizeEvent,
    });
    return client;
  }).catch(() => { loading = undefined; return null; });
  return loading;
}
export { config as analyticsConfig };
